import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSnackbar } from "../../../../../context/SnackbarContext";
import { useInstanceByName } from "../../../../../api/instances/instances";
import Title from "../../../../../components/Title";
import Back from "../../../../../components/Back";
import { Box, CircularProgress, Typography, Paper } from "@mui/material";

export default function InstanceView() {
  const { name } = useParams<{ name: string }>();
  const { showSnackbar } = useSnackbar();

  const { data, isLoading, error } = useInstanceByName(name);

  useEffect(() => {
    if (error) {
      showSnackbar("Failed to load instance", "error");
    }
  }, [error, showSnackbar]);

  if (isLoading) return <CircularProgress />;

  if (!data || !data[0]) return <Typography>No instance found.</Typography>;

  const instance = data[0];

  return (
    <Paper sx={{ p: 3 }}>
      <Title>Instance: {instance.name}</Title>
      <Box sx={{ mb: 2 }}>
        <b>ID:</b> {instance.id}
      </Box>
      <Box sx={{ mb: 2 }}>
        <b>Status:</b> {instance.status}
      </Box>
      <Box sx={{ mb: 2 }}>
        <b>Machine Type:</b> {instance.machine}
      </Box>
      <Box sx={{ mb: 2 }}>
        <b>CPU Platform:</b> {instance.platform}
      </Box>
      <Box sx={{ mb: 2 }}>
        <b>Created:</b> {instance.created}
      </Box>
      <Back />
    </Paper>
  );
}
